import styled, { keyframes, css } from 'styled-components';
import { animated } from 'react-spring';
import { _DivProps } from 'styles/base';

const appearFromLeft = keyframes`
  from{
    opacity: 0;
    transform: translateX(-150px);
  } to {
    opacity: 1;
    transform: translateX(0px);
  }
`;

interface LinkProps extends _DivProps {
  $delay?: number;
  $duration?: number;
}

interface CatProps {
  $chosen: boolean;
}

export const Wrapper = styled.div<_DivProps>`
  display: flex;
  flex-direction: column;

  div {
    margin-top: 25px;
    & + div {
      margin-top: 15px;
    }
  }
`;

export const AnimatedDiv = styled.div<LinkProps>`
  opacity: 0;
  transform: translateX(-150px);

  animation: ${appearFromLeft} ${({$duration}) => $duration || 1}s ease forwards;
  transition: all 0.5s;

  button,
  a {
    background: #fff;
    border-radius: 5px;
    border: 2px solid #efefef;
    padding: 5px 15px 5px 10px;
    box-shadow: 2px 5px 10px 0px rgba(0, 0, 0, 0.5);

    width: 100%;
    display: flex;
    align-items: center;

    text-decoration: none;

    transition: all 0.5s;
    svg {
      margin-right: 15px;
      color: #363636;
      transition: all 0.5s;
    }

    h3 {
      font-size: 18.72px;
      color: #767676;
      transition: all 0.5s;
    }
  }

  ${({$delay}) =>
    $delay &&
    css`
      animation-delay: ${$delay}s;
    `}

  &:hover {
    button,
    a {
      transform: translateX(10px);
      box-shadow: 2px 5px 10px 3px rgba(0, 0, 0, 0.5);
      svg {
        color: #767676;
      }
      h3 {
        color: #332e2e;
      }
    }
  }
`;

export const ButtonsContainer = styled(animated.div)<_DivProps>`
  margin: 10px;
  display: grid;
  column-gap: 15px;
  /* width: 90vw; */
  grid: auto / 1fr 1fr 1fr 1fr;

  /* display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 0px 0px 0px; */

  @media screen and (max-width: 730px) {
    grid: auto / 1fr 1fr;
    row-gap: 15px;
  }
`;

export const CategoryButton = styled.button<CatProps>`
  font-size: 16px;
  width: 170px;
  padding: 2px 3px;
  background: #fff;
  border: 2px solid #efefef;
  border-radius: 3px;
  box-shadow: 1px 2.5px 5px 1.5px rgba(0, 0, 0, 0.5);

  ${({$chosen}) =>
    $chosen &&
    css`
      color: #332e2e;
      /* text-shadow: 0px 0px 1px #8a0002; */
      font-weight: bold;
      background-color: #ffebeb;
      border-color: #8a0002;
      box-shadow: 2px 5px 10px 3px rgba(0, 0, 0, 0.5);
    `}
`;
//
